import React from "react";
import Layout from "../components/Layout/Layout";
import AboutHeroSection from "../components/about/AboutHeroSection";

const About = () => {
  return (
    <Layout title="About us - Medicure">
      <AboutHeroSection />
    </Layout>
  );
};

export default About;
